/**
 * @prettier
 * @author Alexander Nagelberg
 *
 **/
import React from 'react'

import NavLink from 'app/components/util/lgy-nav-link/LgyNavLink'

const FundingFeeNav = ({ authorizations }) => {
  return (
    <div className='sidenav sticky usa-width-one-fourth lgy-funding-fee-nav'>
      <ul className='usa-sidenav-list'>
        {authorizations.includes('View Funding Fee Refund Record') && (
          <li>
            <NavLink activeClassName='usa-current' to='/lgyhub/funding-fee/refunds/processing'>
              Refund Processing
            </NavLink>
          </li>
        )}
        {authorizations.includes('View Funding Fee Refund Record') && (
          <li>
            <NavLink activeClassName='usa-current' to='/lgyhub/funding-fee/refunds/search'>
              Search Refunds
            </NavLink>
          </li>
        )}
        {authorizations.includes('Generate Funding Fee Refund Pre-Screen Report') && (
          <li>
            <NavLink activeClassName='usa-current' to='/lgyhub/funding-fee/refunds/report/prescreen'>
              Pre-Screen Reports
            </NavLink>
          </li>
        )}
        {authorizations.includes('Generate Funding Fee Refund Payment') && (
          <li>
            <NavLink activeClassName='usa-current' to='/lgyhub/funding-fee/refunds/report/payment'>
              Payment Reports
            </NavLink>
          </li>
        )}
      </ul>
    </div>
  )
}

export default FundingFeeNav
